export default "__VITE_ASSET__B5UZ4wXR__"